import { signupFormChanged } from '../../store/shared-signup';
import { getRegions } from './avatax';

import type { Dispatch } from '@avalara/types/actions';
import type { NewAccountFormField } from '@avalara/types/index';
import type { State } from '@avalara/types/reducer-states';

export const updateSignupForm =
  (field: NewAccountFormField, value: string) => async (dispatch: Dispatch, getState: () => State) => {
    if (field === 'country') {
      const { countries } = getState().data;
      if (!countries.some((c) => c.code === value)) return;
    }

    dispatch(signupFormChanged({ field, value }));

    if (field === 'country') dispatch(getRegions(value));
  };
